export default __webpack_public_path__ + "static/media/kitchen4-afterA-1920w.bd93e782.png";